var exports = {
  "k": "x127c5a35--4d0224--container",
};

module.exports = exports;
